// src/components/NoteEditor.js
import React, { useState, useEffect, useRef } from "react";
import ColorSelect from "./ColorSelect";
import { useTranslation } from 'react-i18next';
import "../css/Note.css";


const NoteEditor = ({
  initialColor,
  colorOptions,
  onSave,
  onCancel,
  scanResultId = null,
  showCategory = true,
  existingNote = null, // ajouté
}) => {
  const { t } = useTranslation();
  const textareaRef = useRef(null);

  const [text, setText] = useState(existingNote ? existingNote.text : "");
  const [selectedColor, setSelectedColor] = useState(
    existingNote
      ? colorOptions.find((opt) => opt.id === existingNote.categoryId) || colorOptions[0]
      : initialColor || colorOptions[0]
  );
  const translatedColorOptions = colorOptions.map(opt => ({
    ...opt,
    label: t(`note.input.${opt.id}`)
  }));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (textareaRef.current) textareaRef.current.focus();
  }, []);

  // Si la note change (ex: passage d'une nouvelle note à une édition)
  useEffect(() => {
    if (existingNote) {
      setText(existingNote.text);
      const colorObj =
        colorOptions.find((opt) => opt.id === existingNote.categoryId) ||
        colorOptions[0];
      setSelectedColor(colorObj);
    } else {
      setText("");
      setSelectedColor(initialColor || colorOptions[0]);
    }
  }, [existingNote, colorOptions, initialColor]);

  const handleSave = async () => {
    if (!text.trim()) return;
    setLoading(true);

    try {
      const note = {
        text,
        categoryId: selectedColor.id,
        scanResultId: scanResultId || null,
      };

      onSave(note);
      setText("");
      onCancel();
    } catch (err) {
      console.error("Erreur :", err);
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="note-editor">
      {showCategory && (
        <div
          className="note-category"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginBottom: "10px",
          }}
        >
          <label>{t(`note.input.category`)}</label>
          <ColorSelect
            value={selectedColor.color}
            onChange={(newColor) => {
              const colorObj = colorOptions.find(
                (opt) => opt.color === newColor
              );
              setSelectedColor(colorObj || colorOptions[0]);
            }}
            options={translatedColorOptions}
            style={{ display: "flex", alignItems: "center" }}
          />
        </div>
      )}

      <textarea
        ref={textareaRef}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={t(`note.input.text`)}
        rows={6}
      />

      <div className="note-actions">
        <button
          className="note-btn save-btn"
          style={{ backgroundColor: selectedColor.color }}
          onClick={handleSave}
          disabled={loading}
        >
          {loading
            ? "Sauvegarde..."
            : existingNote
            ? t(`note.input.update`)
            : t(`note.input.save`)}
        </button>
        {onCancel && (
          <button
            className="note-btn cancel-btn"
            onClick={onCancel}
            disabled={loading}
          >
            {t(`note.input.cancel`)}
          </button>
        )}
      </div>
    </div>
  );
};

export default NoteEditor;
